import PartyAttr from '@/axios/party-attribute-endpoint'

export const defaultStartDate = {
  methods: {
    getPartyDefaultStartDate ({ values = [], partyId = null }) {
      if (partyId) {
        return this.getPartyAttrValues(partyId)
      }
      if (values.length === 0) return null;
      
      const hasStore = values.some(v => v.attr.party_type?.constant === 'STORE');
      const beginDate = hasStore ? values.find(v => v.attr.id === 'BEGIN_DATE') : null;
      if (beginDate) return beginDate.value;
      
      const timeSensitive = values.find(v => v.attr.is_time_sensitive);
      return timeSensitive?.start_dt || null;
    },
    async getPartyAttrValues (partyId, limit = 100, offset = 0) {
      const res = await PartyAttr.attributeValue.getList(partyId, limit, offset)
      const values = res.data
      return this.getPartyDefaultStartDate({ values })
    }
  }
}
